import React, { useMemo } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Squircle from 'design-system/Squircle';
import { CardView, IconClose, Spacer, rem } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import useColors from 'hooks/useColors';
import IconCheck from 'design-system/icons/IconCheck';
import TimeInfo from 'design-system/TimeInfo';
const ProgressCard = ({ title, lightBg, children, timeInfo, lastItem, completed, isActiveStep, isActionRequired, isFailure, noTextDecoration, alwaysShowTimeline, alwaysShowChildren, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const progressIcon = useMemo(() => {
        if (isFailure) {
            return (<Squircle width={rem(24)} height={rem(24)} color={colors.status.negativeLight}>
          <Spacer h={2}/>
          <IconClose fat alt size={rem(20)} color={colors.status.negative}/>
        </Squircle>);
        }
        if (completed) {
            return (<Squircle width={rem(24)} height={rem(24)} color={colors.buttons.brandGroup}>
          <Spacer h={2}/>
          <IconCheck alt width={rem(12)} height={rem(12)}/>
        </Squircle>);
        }
        if (isActiveStep) {
            const color = isActionRequired ? colors.elements.statusNegative : colors.elements.brand;
            return (<Squircle width={rem(28)} height={rem(28)} color={color}>
          <Squircle width={rem(24)} height={rem(24)} color={colors.background.light}>
            <Squircle width={rem(16)} height={rem(16)} color={color}/>
          </Squircle>
        </Squircle>);
        }
        return (<Squircle width={rem(18)} height={rem(18)} color={colors.buttons.brandGroup}>
        <Squircle width={rem(14)} height={rem(14)} color={lightBg ? colors.background.dark : colors.background.light}/>
      </Squircle>);
    }, [colors, completed, isActionRequired, isActiveStep, lightBg, isFailure]);
    return (<View style={styles.container}>
      <View style={styles.progressView}>
        {progressIcon}
        <Spacer h={16}/>
        {!lastItem && <View style={styles.lineView}/>}
      </View>
      <Spacer w={16}/>
      <CardView withPadding style={[
            styles.card,
            !!lightBg && styles.lightBg,
            !completed && !!isActiveStep && !isFailure && styles.activeStep,
            !completed && isActionRequired && styles.actionRequired,
        ]} noMargin>
        {!!timeInfo && (!completed || !!alwaysShowTimeline) && (<>
            <TimeInfo title={timeInfo}/>
            <Spacer h={4}/>
          </>)}
        <Text Text-16 {...((completed || !isActiveStep) && !noTextDecoration && { Secondary: true })} style={completed && !noTextDecoration ? styles.completedText : null}>
          {title}
        </Text>
        {(!completed || !!alwaysShowChildren) && !!children && (<>
            <Spacer h={4}/>
            {children}
          </>)}
      </CardView>
    </View>);
};
export default ProgressCard;
const styleSet = createStyleSheets((colors) => ({
    container: {
        paddingTop: rem(16),
        flexDirection: 'row',
        paddingHorizontal: rem(32),
    },
    card: {
        flex: 1,
        borderWidth: 1,
        marginBottom: rem(16),
        borderColor: colors.cards.onLight,
        backgroundColor: colors.cards.onLight,
    },
    lightBg: {
        backgroundColor: colors.cards.onDark,
    },
    completedText: {
        textDecorationStyle: 'solid',
        textDecorationLine: 'line-through',
    },
    activeStep: {
        borderWidth: 1,
        borderColor: colors.text.brand,
    },
    actionRequired: {
        borderWidth: 1,
        borderColor: colors.elements.statusNegative,
    },
    progressView: {
        width: rem(28),
        alignItems: 'center',
    },
    lineView: {
        flex: 1,
        width: rem(2),
        borderRadius: rem(2),
        backgroundColor: colors.buttons.brandGroup,
    },
}));
